module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-150x150.e5eade5f68c6d566ed3ffd7ac6cd5e40.png";